<template>
  <div class="mobileCategorizedProductDisplay">
    <div class="CategorizedHeader">
      <div class="Header_left">Just For You</div>
      <div class="Header_right"></div>
    </div>
    <div class="CategorizedGoodList">
      <div class="GoodItem"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      title: '',
    };
  },
  components: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.mobileCategorizedProductDisplay {
  .CategorizedHeader {
    display: flex;
    font-size: 0.16rem;
    font-weight: 700;
  }
  .CategorizedGoodList {
    .GoodItem {
      //
    }
  }
}
</style>
